__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-search-locations'].baseUrl;
import ModuleContainer from './components/TravelSearchLocations';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/conditional-features': '^3.3.0',
      '@americanexpress/fetchye-amex': '^0.13.0',
      '@americanexpress/one-app-module-wrapper': '^3.4.2',
      '@americanexpress/one-experiments': '^2.1.5',
      '@americanexpress/travel-selectors': '^5.0.0',
      'iguazu': '^3.2.0',
      'iguazu-rest': '^1.8.0',
      'react-intl': '^6.3.2',
      'xss': '^1.0.15'
    }
  });
}